<template>
  <!--
    Example Data
    { name: 'foo', input_type: "autocomplete", options: ['list', 'of', 'values'], multiple: boolean}
  -->
  <v-row>
    <v-col md="3">
      <div class="mr-5 mt-6">
        <div class="text-right subtitle font-weight-bold">{{ value.name | capitalize }}</div>
      </div>
    </v-col>
    <v-col class="d-flex d-inline" md="9" >
        <v-autocomplete
          v-if="value.multiple"
          :items="autocompleteItems"
          item-text="label"
          item-value="value"
          :label="value.name | capitalize"
          :value="modelValue[value.name]"
          :rules="vruleSelectRequired"
          required
          multiple
          chips
          prepend-icon="mdi-database-search"
          v-on:change="updateQueryParam($event)"
        >
          <template v-slot:prepend-item>
            <v-list-item
              ripple
              @click="toggle"
            >
            <v-list-item-action>
              <v-icon :color="(modelValue[value.name] || []).length > 0 ? 'indigo darken-4' : ''">{{ selectIcon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Select All</v-list-item-title>
            </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
       </v-autocomplete>

        <v-autocomplete
          v-if="!value.multiple"
          :items="autocompleteItems"
          item-text="label"
          item-value="value"
          :label="value.name | capitalize"
          :value="modelValue[value.name]"
          :rules="vruleFieldRequired"
          required
          prepend-icon="mdi-database-search"
          v-on:change="updateQueryParam($event)"
        ></v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
import validationMixin from '@/validators/validations_mixin'
import SelectDeselectAllMixin from './SelectDeselectAllMixin'

export default {
  name: 'autocomplete-input-field',
  inputType: 'autocomplete',
  mixins: [validationMixin, SelectDeselectAllMixin],
  props: {
    value: {
      type: Object,
      require: true
    },
    paramName: {
      type: String,
      require: true
    },
    modelValue: {
      type: Object,
      require: true
    },
    errorMessages: {
      type: Array
    }
  },
  data: function () {
    return {}
  },
  computed: {
    autocompleteItems () {
      if (this.value.options.length > 0) {
        if (typeof this.value.options[0] === 'object') {
          return this.value.options
        } else {
          // must be a string or number in a list - format in object notation
          return this.value.options.map((o) => {
            return { label: o, value: o }
          })
        }
      } else {
        return []
      }
    }
  }
}
</script>
